import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { PageHeader } from '@/components/page-header'
import { GroupHealthSection } from '@/features/reports/group-health'

/** Group health, as an addressable screen of its own. */
export function ReportsGroupHealthPage() {
  return (
    <>
      <Link
        to="/reports"
        className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-text hover:text-brand-text-hover max-lg:min-h-11 max-lg:py-2"
      >
        <ArrowLeft className="size-3.5" aria-hidden />
        All reports
      </Link>

      <PageHeader
        title="Group health"
        description="Every group's standing and portfolio quality as at a date, qualifying or not."
      />

      <GroupHealthSection />
    </>
  )
}
